var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",class:_vm.theme},[_c('div',{staticClass:"title-group"},[_c('h3',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.title))]),_c('h4',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.text))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }